import { render, staticRenderFns } from "./2fa.vue?vue&type=template&id=3e08641f"
import script from "./2fa.vue?vue&type=script&lang=ts"
export * from "./2fa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports